import gql from 'graphql-tag'

export const deviceInviteServiceCompany = gql`
  mutation deviceInviteServiceCompany($deviceId: ID!, $email: EmailAddress!) {
    deviceInviteServiceCompany(input: { deviceId: $deviceId, email: $email }) {
      success
    }
  }
`
